module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Like-c2a76fb669eb4c91a6ad01d26046b1e5.svg";